// extracted by mini-css-extract-plugin
module.exports = {"video__player":"VideoPlayer_video__player__P2Zmf"};